// extracted by mini-css-extract-plugin
export default {"icons":"SideBarNavigation_icons__PJMHJ","linkManual":"SideBarNavigation_linkManual__2mdrL"};